import React, { useState } from 'react';
import './App.css';
import './../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './../node_modules/bootstrap/dist/js/bootstrap.bundle.js';


import data from './NewCommunityGrocery/Data'; //NewCommunityGrocery
import Navbar from './navbar';   //NewCommunityGrocery
import Routes from './NewCommunityGrocery/Routes';   //NewCommunityGrocery
import Product from './NewCommunityGrocery/Product';
import { useDispatch, useSelector } from "react-redux";
import { LoginPage } from './Home/LoginPage';



export const App = () => {
  const { productItems } = data;  //NewCommunityGrocery
  const [cartItems, setCartItems] = useState([]); //NewCommunityGrocery
  const userInfo = useSelector((state) => state.authentication.userInfo);
  const isLoggedIn = useSelector((state) => state.authentication.isLoggedIn);
  const [selectedOrder, setSelectedOrder] = useState(null);


  const handleAddProduct = (product) => {
    const ProductExist = cartItems.find((item) => item.id === product.id);
    if (ProductExist) {
      setCartItems(cartItems.map((item) => item.id === product.id ?
        { ...ProductExist, quantity: ProductExist.quantity + 1 } : item)
      );
    }
    else {
      setCartItems([...cartItems, { ...product, quantity: 1 }]);
    }
  };

  const handleRemoveProduct = (product) => {
    const ProductExist = cartItems.find((item) => item.id === product.id);
    if (ProductExist.quantity === 1) {
      setCartItems(cartItems.filter((item) => item.id !== product.id));
    } else {
      setCartItems(
        cartItems.map((item) =>
          item.id === product.id ? { ...ProductExist, quantity: ProductExist.quantity - 1 } : item
        )
      );
    }
  };

  const handleCartClearance = () => {
    setCartItems([]);
  }

  const totalItems = cartItems.reduce(
    (quantity, item) => quantity + item.quantity, 0
  );

  const setOrder = (order) =>{
    console.log(order);
    setSelectedOrder(order);
  }
  return (
    <>
      <div class="container-fluid">
        <section className="row shopping-cart-page">
          {
            !isLoggedIn?
            <LoginPage></LoginPage>
            :
            <>
              <div className="col-12 order-header">
                <Navbar cartItems={cartItems} placeholder={"Search Product"} handleChange={(e) => this.setState({ searchField: e.target.value })} />
              </div>
              <div className="col-12 order-body">
                <Routes productItems={productItems} cartItems={cartItems} orderDetail={selectedOrder} handleOrderSelection={(order)=>setOrder(order)} handleAddProduct={handleAddProduct} handleRemoveProduct={handleRemoveProduct} handleCartClearance={handleCartClearance} />  {/*  //NewCommunityGrocery */}
              </div>
            </>

          }
        </section>
      
      </div>
    </>
  )
}


export default App;